import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { getCashRegisters } from "./slice";
import { CashRegisterParameters } from "./api";

export const useCashRegisters = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.cashRegisters);
  const dispatch = useAppDispatch();

  const getCashRegistersHandler = useCallback(
    (data?: CashRegisterParameters) =>
      dispatch(getCashRegisters({ userId, data })),
    [dispatch, userId]
  );

  return {
    state,
    getCashRegisters: getCashRegistersHandler,
  };
};
